var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 79,
    r: 77.5,
    fill: "white",
    stroke: "#1F1E1E",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 81.2214L71.4445 76.777L75.889 76.777L75.889 81.2214L71.4445 81.2214Z",
    fill: "#1F1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 81.2214L89.2223 76.777L93.6668 76.777L93.6668 81.2214L89.2223 81.2214Z",
    fill: "#1F1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 81.2214L75.889 76.777L80.3334 76.777L80.3334 81.2214L75.889 81.2214Z",
    fill: "#1F1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6668 81.2214L93.6668 76.777L98.1112 76.777L98.1112 81.2214L93.6668 81.2214Z",
    fill: "#1F1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1112 81.2214L98.1112 76.777L102.556 76.777L102.556 81.2214L98.1112 81.2214Z",
    fill: "#1F1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 81.2214L80.3334 76.777L84.7779 76.777L84.7779 81.2214L80.3334 81.2214Z",
    fill: "#1F1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 81.2214L84.7779 76.777L89.2223 76.777L89.2223 81.2214L84.7779 81.2214Z",
    fill: "#1F1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 90.1103L67.0001 85.6659L71.4445 85.6659L71.4445 90.1103L67.0001 90.1103Z",
    fill: "#1F1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 94.5548L67.0001 90.1103L71.4445 90.1103L71.4445 94.5548L67.0001 94.5548Z",
    fill: "#1F1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 94.5548L71.4445 90.1103L75.889 90.1103L75.889 94.5548L71.4445 94.5548Z",
    fill: "#1F1E1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 90.1103L71.4445 85.6659L75.889 85.6659L75.889 90.1103L71.4445 90.1103Z",
    fill: "#1F1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 85.6659L71.4445 81.2214L75.889 81.2214L75.889 85.6659L71.4445 85.6659Z",
    fill: "#1F1E1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 98.9992L71.4445 94.5548L75.889 94.5548L75.889 98.9992L71.4445 98.9992Z",
    fill: "#1F1E1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 94.5548L75.889 90.1103L80.3334 90.1103L80.3334 94.5548L75.889 94.5548Z",
    fill: "#1F1E1E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 90.1103L75.889 85.6659L80.3334 85.6659L80.3334 90.1103L75.889 90.1103Z",
    fill: "#1F1E1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 85.6659L75.889 81.2214L80.3334 81.2214L80.3334 85.6659L75.889 85.6659Z",
    fill: "#1F1E1E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 85.6659L89.2223 81.2214L93.6668 81.2214L93.6668 85.6659L89.2223 85.6659Z",
    fill: "#1F1E1E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 98.9992L75.889 94.5548L80.3334 94.5548L80.3334 98.9992L75.889 98.9992Z",
    fill: "#1F1E1E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 94.5548L80.3334 90.1103L84.7779 90.1103L84.7779 94.5548L80.3334 94.5548Z",
    fill: "#1F1E1E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 90.1103L80.3334 85.6659L84.7779 85.6659L84.7779 90.1103L80.3334 90.1103Z",
    fill: "#1F1E1E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 85.6659L80.3334 81.2214L84.7779 81.2214L84.7779 85.6659L80.3334 85.6659Z",
    fill: "#1F1E1E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6668 85.6659L93.6668 81.2214L98.1112 81.2214L98.1112 85.6659L93.6668 85.6659Z",
    fill: "#1F1E1E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 98.9992L80.3334 94.5548L84.7779 94.5548L84.7779 98.9992L80.3334 98.9992Z",
    fill: "#1F1E1E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 94.5548L84.7779 90.1103L89.2223 90.1103L89.2223 94.5548L84.7779 94.5548Z",
    fill: "#1F1E1E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 90.1103L84.7779 85.6659L89.2223 85.6659L89.2223 90.1103L84.7779 90.1103Z",
    fill: "#1F1E1E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 85.6659L84.7779 81.2214L89.2223 81.2214L89.2223 85.6659L84.7779 85.6659Z",
    fill: "#1F1E1E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 90.1103L89.2223 85.6659L93.6668 85.6659L93.6668 90.1103L89.2223 90.1103Z",
    fill: "#1F1E1E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 85.6659L67.0001 81.2214L71.4445 81.2214L71.4445 85.6659L67.0001 85.6659Z",
    fill: "#1F1E1E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 67.8881L67.0001 72.3326L71.4445 72.3326L71.4445 67.8881L67.0001 67.8881Z",
    fill: "#1F1E1E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 63.4437L67.0001 67.8881L71.4445 67.8881L71.4445 63.4437L67.0001 63.4437Z",
    fill: "#1F1E1E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 63.4437L71.4445 67.8881L75.889 67.8881L75.889 63.4437L71.4445 63.4437Z",
    fill: "#1F1E1E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 67.8881L71.4445 72.3326L75.889 72.3326L75.889 67.8881L71.4445 67.8881Z",
    fill: "#1F1E1E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 72.3326L71.4445 76.777L75.889 76.777L75.889 72.3326L71.4445 72.3326Z",
    fill: "#1F1E1E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 58.9992L71.4445 63.4437L75.889 63.4437L75.889 58.9992L71.4445 58.9992Z",
    fill: "#1F1E1E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 63.4437L75.889 67.8881L80.3334 67.8881L80.3334 63.4437L75.889 63.4437Z",
    fill: "#1F1E1E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 67.8881L75.889 72.3326L80.3334 72.3326L80.3334 67.8881L75.889 67.8881Z",
    fill: "#1F1E1E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 72.3326L75.889 76.777L80.3334 76.777L80.3334 72.3326L75.889 72.3326Z",
    fill: "#1F1E1E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 72.3326L89.2223 76.777L93.6668 76.777L93.6668 72.3326L89.2223 72.3326Z",
    fill: "#1F1E1E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 58.9992L75.889 63.4437L80.3334 63.4437L80.3334 58.9992L75.889 58.9992Z",
    fill: "#1F1E1E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 63.4437L80.3334 67.8881L84.7779 67.8881L84.7779 63.4437L80.3334 63.4437Z",
    fill: "#1F1E1E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 67.8881L80.3334 72.3326L84.7779 72.3326L84.7779 67.8881L80.3334 67.8881Z",
    fill: "#1F1E1E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 72.3326L80.3334 76.777L84.7779 76.777L84.7779 72.3326L80.3334 72.3326Z",
    fill: "#1F1E1E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6668 72.3326L93.6668 76.777L98.1112 76.777L98.1112 72.3326L93.6668 72.3326Z",
    fill: "#1F1E1E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3334 58.9992L80.3334 63.4437L84.7779 63.4437L84.7779 58.9992L80.3334 58.9992Z",
    fill: "#1F1E1E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 63.4437L84.7779 67.8881L89.2223 67.8881L89.2223 63.4437L84.7779 63.4437Z",
    fill: "#1F1E1E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 67.8881L84.7779 72.3326L89.2223 72.3326L89.2223 67.8881L84.7779 67.8881Z",
    fill: "#1F1E1E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 72.3326L84.7779 76.777L89.2223 76.777L89.2223 72.3326L84.7779 72.3326Z",
    fill: "#1F1E1E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 67.8881L89.2223 72.3326L93.6668 72.3326L93.6668 67.8881L89.2223 67.8881Z",
    fill: "#1F1E1E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 72.3326L67.0001 76.777L71.4445 76.777L71.4445 72.3326L67.0001 72.3326Z",
    fill: "#1F1E1E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 54.5548L75.889 58.9992L80.3334 58.9992L80.3334 54.5548L75.889 54.5548Z",
    fill: "#1F1E1E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 54.5548L71.4445 58.9992L75.889 58.9992L75.889 54.5548L71.4445 54.5548Z",
    fill: "#1F1E1E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 54.5548L67.0001 58.9992L71.4445 58.9992L71.4445 54.5548L67.0001 54.5548Z",
    fill: "#1F1E1E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 58.9992L67.0001 63.4437L71.4445 63.4437L71.4445 58.9992L67.0001 58.9992Z",
    fill: "#1F1E1E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 50.1103L67.0001 54.5548L71.4445 54.5548L71.4445 50.1103L67.0001 50.1103Z",
    fill: "#1F1E1E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 76.777L67.0001 81.2214L71.4445 81.2214L71.4445 76.777L67.0001 76.777Z",
    fill: "#1F1E1E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 94.5548L67.0001 98.9992L71.4445 98.9992L71.4445 94.5548L67.0001 94.5548Z",
    fill: "#1F1E1E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 98.9992L67.0001 103.444L71.4445 103.444L71.4445 98.9992L67.0001 98.9992Z",
    fill: "#1F1E1E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 98.9992L71.4445 103.444L75.889 103.444L75.889 98.9992L71.4445 98.9992Z",
    fill: "#1F1E1E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 98.9992L75.889 103.444L80.3334 103.444L80.3334 98.9992L75.889 98.9992Z",
    fill: "#1F1E1E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 103.444L67.0001 107.888L71.4445 107.888L71.4445 103.444L67.0001 103.444Z",
    fill: "#1F1E1E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 58.9992L84.7779 63.4437L89.2223 63.4437L89.2223 58.9992L84.7779 58.9992Z",
    fill: "#1F1E1E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 63.4437L89.2223 67.8881L93.6668 67.8881L93.6668 63.4437L89.2223 63.4437Z",
    fill: "#1F1E1E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6668 67.8881L93.6668 72.3326L98.1112 72.3326L98.1112 67.8881L93.6668 67.8881Z",
    fill: "#1F1E1E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1112 72.3326L98.1112 76.777L102.556 76.777L102.556 72.3326L98.1112 72.3326Z",
    fill: "#1F1E1E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6668 90.1103L93.6668 85.6659L98.1112 85.6659L98.1112 90.1103L93.6668 90.1103Z",
    fill: "#1F1E1E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1112 85.6659L98.1112 81.2214L102.556 81.2214L102.556 85.6659L98.1112 85.6659Z",
    fill: "#1F1E1E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M102.556 81.2214L102.556 76.777L107 76.777L107 81.2214L102.556 81.2214Z",
    fill: "#1F1E1E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 50.1103L75.889 54.5548L80.3334 54.5548L80.3334 50.1103L75.889 50.1103Z",
    fill: "#1F1E1E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 50.1103L71.4445 54.5548L75.889 54.5548L75.889 50.1103L71.4445 50.1103Z",
    fill: "#1F1E1E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 45.6658L67.0001 50.1103L71.4445 50.1103L71.4445 45.6658L67.0001 45.6658Z",
    fill: "#1F1E1E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 45.6658L71.4445 50.1103L75.889 50.1103L75.889 45.6658L71.4445 45.6658Z",
    fill: "#1F1E1E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M75.889 103.444L75.889 107.888L80.3334 107.888L80.3334 103.444L75.889 103.444Z",
    fill: "#1F1E1E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 103.444L71.4445 107.888L75.889 107.888L75.889 103.444L71.4445 103.444Z",
    fill: "#1F1E1E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4445 107.888L71.4445 112.332L75.889 112.332L75.889 107.888L71.4445 107.888Z",
    fill: "#1F1E1E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 107.888L67.0001 112.332L71.4445 112.332L71.4445 107.888L67.0001 107.888Z",
    fill: "#1F1E1E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 90.1108L62.5556 85.6664L67.0001 85.6659L67.0001 90.1103L62.5556 90.1108Z",
    fill: "#1F1E1E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 94.5552L62.5556 90.1108L67.0001 90.1103L67.0001 94.5548L62.5556 94.5552Z",
    fill: "#1F1E1E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 85.6664L62.5556 81.2219L67.0001 81.2214L67.0001 85.6659L62.5556 85.6664Z",
    fill: "#1F1E1E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 67.8886L62.5556 72.333L67.0001 72.3326L67.0001 67.8881L62.5556 67.8886Z",
    fill: "#1F1E1E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 63.4442L62.5556 67.8886L67.0001 67.8881L67.0001 63.4437L62.5556 63.4442Z",
    fill: "#1F1E1E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 72.333L62.5556 76.7775L67.0001 76.777L67.0001 72.3326L62.5556 72.333Z",
    fill: "#1F1E1E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 54.5553L62.5556 58.9997L67.0001 58.9992L67.0001 54.5548L62.5556 54.5553Z",
    fill: "#1F1E1E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 58.9997L62.5556 63.4442L67.0001 63.4437L67.0001 58.9992L62.5556 58.9997Z",
    fill: "#1F1E1E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 50.1107L62.5556 54.5553L67.0001 54.5548L67.0001 50.1103L62.5556 50.1107Z",
    fill: "#1F1E1E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 76.7775L62.5556 81.2219L67.0001 81.2214L67.0001 76.777L62.5556 76.7775Z",
    fill: "#1F1E1E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 94.5552L62.5556 98.9997L67.0001 98.9992L67.0001 94.5548L62.5556 94.5552Z",
    fill: "#1F1E1E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 98.9997L62.5556 103.444L67.0001 103.444L67.0001 98.9992L62.5556 98.9997Z",
    fill: "#1F1E1E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 103.444L62.5556 107.888L67.0001 107.888L67.0001 103.444L62.5556 103.444Z",
    fill: "#1F1E1E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 45.6663L62.5556 50.1107L67.0001 50.1103L67.0001 45.6658L62.5556 45.6663Z",
    fill: "#1F1E1E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 107.888L62.5556 112.332L67.0001 112.332L67.0001 107.888L62.5556 107.888Z",
    fill: "#1F1E1E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 41.2218L62.5556 45.6663L67.0001 45.6658L67.0001 41.2213L62.5556 41.2218Z",
    fill: "#1F1E1E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 112.332L62.5554 116.777L66.9999 116.777L67.0001 112.332L62.5556 112.332Z",
    fill: "#1F1E1E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 98.9992L84.7779 94.5548L89.2223 94.5548L89.2223 98.9992L84.7779 98.9992Z",
    fill: "#1F1E1E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2223 94.5548L89.2223 90.1103L93.6668 90.1103L93.6668 94.5547L89.2223 94.5548Z",
    fill: "#1F1E1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.49e5672942777e98e4c79b3e66aaabd4.svg";
export { ForwardRef as ReactComponent };